import type { SolutionGasRsoCalculator } from "../../d";

export const solutionGasRsoCalculator: SolutionGasRsoCalculator = (
  params
): {
  solutionGasRsoInSitu: number;
  solutionGasRsoAtReservoir: number;
  a: number;
  aReservoir: number;
} => {
  const {
    gasSpecificGravity,
    oilAPI,
    temperatureF,
    inSituPressurePSIA,
    reservoirPressurePSIA,
    gasOilRatio
  } = params;
  // D120: =2.8869-(14.1811-3.3093*LOG10(D3))**0.5
  const a = 2.8869 - (14.1811 - 3.3093 * Math.log10(inSituPressurePSIA)) ** 0.5;
  // D122: =D8*(((D7**0.989)/(D4**0.172))*10**D120)**1.2255
  const solutionGasRsoInSitu =
    gasSpecificGravity *
    ((oilAPI ** 0.989 / temperatureF ** 0.172) * 10 ** a) ** 1.2255;
  // D124: =2.8869-(14.1811-3.3093*LOG10(D12))**0.5
  const aReservoir =
    2.8869 - (14.1811 - 3.3093 * Math.log10(reservoirPressurePSIA)) ** 0.5;
  // D126: =D8*(((D7**0.989)/(D4**0.172))*10**D124)**1.2255
  const solutionGasRsoAtReservoir =
    gasSpecificGravity *
    ((oilAPI ** 0.989 / temperatureF ** 0.172) * 10 ** aReservoir) ** 1.2255;

  return {
    solutionGasRsoAtReservoir:
      solutionGasRsoAtReservoir > gasOilRatio
        ? gasOilRatio
        : solutionGasRsoAtReservoir,
    solutionGasRsoInSitu:
      solutionGasRsoInSitu > gasOilRatio ? gasOilRatio : solutionGasRsoInSitu,
    a,
    aReservoir
  };
};
